// ============================================================================
// CENTRAL SITE CONFIGURATION
// Edit ALL company info here. Nothing is hardcoded elsewhere.
// ============================================================================
export const siteConfig = {
  companyName: "Pneu Land Haren",
  siteUrl: "https://pneulandharen.be",
  logoText: "PNEU LAND HAREN",
  logo: "https://customer-assets-jt897jd0.emergentagent.net/job_workshop-elite-be/artifacts/h90nw3jq_Pneu%20Land%20Logo%20%281%29%20%281%29-Photoroom.png",
  phone: "02 726 26 01",
  phoneHref: "tel:+3227262601",
  whatsapp: "32487338672", // digits only, international format
  // Tire brands shown in the scrolling strip on the Tires page (edit freely)
  tireBrands: ["Michelin", "Goodyear", "Bridgestone", "Continental", "Hankook", "Uniroyal", "Firestone"],
  email: "info@pneulandharen.be",
  address: {
    street: "Chaussée de Haecht 1900",
    postalCode: "1130",
    locality: "Bruxelles",
    city: "1130 Bruxelles",
    country: "Belgique",
  },
  // Google Maps (no API key needed — standard embed + directions link)
  maps: {
    embedQuery: "Chaussée de Haecht 1900, 1130 Bruxelles, Belgique",
    directionsUrl:
      "https://www.google.com/maps/dir/?api=1&destination=Chauss%C3%A9e+de+Haecht+1900%2C+1130+Bruxelles%2C+Belgique",
  },
  social: {
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
  },
  // Accent color — change this single value to re-theme the whole site.
  accent: "#E53935",
  accentHover: "#D32F2F",
};

export const openingHours = [
  { dayKey: "monSat", time: "09:00 – 18:00" },
  { dayKey: "sun", time: "closed" },
];

export const whatsappLink = (message) =>
  `https://wa.me/${siteConfig.whatsapp}?text=${encodeURIComponent(message || "")}`;
